import React from 'react';
import './shop-card.scss';
import defaultLogo from '../../asset/images/logo_default.svg';
import defaultPeople from '../../asset/images/person-default.svg';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import { getUrlParam } from '../../helper/dish-helper';
import { getUserName, getUserAvatar, isFormalMeal } from '../../helper/common-helper';
import classnames from 'classnames';
import config from '../../config';
import DinnerSocketHelper from '../../helper/socket-helper';
import SyncOrderToast from '../../component/mui/sync-order-toast.jsx';
import { ShopCardOrderStatus } from '../../helper/const';
import pageHelper from '../../helper/page-helper';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopText from '../../intl/messages/shop';
import globalMessage from '../../intl/messages/global';

const tableId = getUrlParam('tableId');
const shopId = getUrlParam('shopId');

class ShopCard extends React.Component {
  constructor(props) {
    super(props);
    this.closeWindow = this.closeWindow.bind(this);
  }
  componentWillMount() {
    if (!tableId) {
      sessionStorage.removeItem('lastTableInfo');
    }
    this.shouldInitSocketIo = true;
  }
  componentWillReceiveProps(nextProps) {
    const { shopDetail, userInfo, serviceCardVO, enableSyncShoppingCart } = nextProps;
    if (
      tableId &&
      isFormalMeal(shopDetail.diningForm) &&
      userInfo &&
      this.shouldInitSocketIo &&
      serviceCardVO &&
      serviceCardVO.memberVO &&
      enableSyncShoppingCart !== 0
    ) {
      // 如果落地页带有tableId则请求协同购物车(正餐)
      this.shouldInitSocketIo = false;
      this.initDinnerSocketHelper(userInfo, tableId, serviceCardVO);
    }
  }

  initDinnerSocketHelper(userInfo, curTableId, serviceCardVO) {
    const { setSocketCardData } = this.props;
    if (!userInfo) {
      return null;
    }
    const customerId = serviceCardVO.memberVO.customerId;
    const userNickname = getUserName(userInfo);
    const userPicPath = getUserAvatar(userInfo);
    const _userInfo = (this._userInfo = {
      userId: customerId,
      mobile: userInfo.mobile,
      userPicPath,
      userNickname,
      sex: String(userInfo.sex) === '0' || String(userInfo.sex) === '1' ? userInfo.sex : -1,
      shopId,
      tableId: curTableId,
      ownerId: customerId,
    });
    const dinnerSocket = new DinnerSocketHelper();
    const cleanRoomOrderListOne = [];
    const cardItemsObj = {};
    // 情况一
    if (serviceCardVO.cardItems && serviceCardVO.cardItems.length > 0) {
      serviceCardVO.cardItems.forEach((cardItem, index) => {
        if (
          cardItem.orderStatus === ShopCardOrderStatus.ORDERDONE ||
          cardItem.orderStatus === ShopCardOrderStatus.ORDEROBSOLETE ||
          cardItem.orderStatus === ShopCardOrderStatus.ORDERREFUSED
        ) {
          cleanRoomOrderListOne.push(cardItem.tradeId);
        }
        cardItemsObj[cardItem.tradeId] = true;
      });
    }

    dinnerSocket.cleanRoomOrder(cleanRoomOrderListOne, () => {
      dinnerSocket.noticeRoomInfo(_userInfo, res => {
        const cleanRoomOrderListTwo = [];
        // 情况二
        if (res && res.length > 0) {
          res.forEach((item, index) => {
            if (!cardItemsObj[item.orderId]) {
              cleanRoomOrderListTwo.push(item.orderId);
              item.orderId = '';
            }
          });
        }

        // cleanRoomOrder
        dinnerSocket.cleanRoomOrder(cleanRoomOrderListTwo, () => {});
        setSocketCardData(res);
      });
    });
  }

  // 门店首页头部信息
  getShopCardName() {
    const { commercialName, openStatus, commercialLogo, serviceCardVO } = this.props.shopDetail;
    return (
      <div className="shop-card_top">
        <ul className="o-list o-list--modify o-border--top o-border--bottom">
          <li className="o-list__item c-option o-pb c-option--modify">
            <div className={classnames('o-media', { 'o-media--modify': serviceCardVO || tableId })}>
              <span>
                <HttpsProtocolImage src={commercialLogo || defaultLogo} alt="" className="shop-card-img" />
              </span>
              <div className="o-media__body o-media__body--centered">
                <div className="c-description">
                  <div className="c-description__title c-description__title--modify o-fz--16">{commercialName}</div>
                  <div className="c-description__body">
                    <span className="o-label o-label-dark o-fz--14">
                      {openStatus ? formatMessage(shopText.openFlag) : formatMessage(shopText.closedFlag)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
  getCardItems() {
    const { serviceCardVO, shopDetail } = this.props;
    const { memberVO, cardItems } = serviceCardVO;
    let dishUrl = '';
    let addDishUrl = '';
    let detailUrl = '';
    if (isFormalMeal(shopDetail.diningForm)) { // 正餐
      dishUrl = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS`; // 堂食正餐点餐页面
      addDishUrl = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS&addDishes=true`; // 加菜 正餐
      detailUrl = `${config.tradeDetailUncheckURL}?shopId=${shopId}&type=TS`; // 正餐查看订单详情

      if (serviceCardVO.payFirst) {
        detailUrl = `${config.orderallDetailURL}?type=TS&shopId=${shopId}`; // 快餐查看订单详情
      }
    } else if (shopDetail.diningForm === 1) {
      // 快餐  链接地址不同
      dishUrl = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS`; // 快餐堂食点餐页面(与正餐点餐页面一样)
      detailUrl = `${config.orderallDetailURL}?type=TS&shopId=${shopId}`; // 快餐查看订单详情
    } else {
      return null;
    }

    if (!serviceCardVO) {
      // 不带桌台信息 + 未登录
      return null;
    }

    const formatDataZC = (newTableId, newMemberVO, newCardItems, domOne, domTwo, domThree) => {
      // 正餐
      if (newTableId && !newMemberVO) {
        // 带桌台信息+未登录
        if (newCardItems && newCardItems.length !== 0) {
          return domOne;
        }
        return domTwo;
      } else if (newTableId && newMemberVO) {
        // 带桌台信息+已登录
        if (newCardItems && newCardItems.length !== 0) {
          return domOne;
        }
        return domTwo;
      } else if (!newTableId && newMemberVO) {
        // 不带桌台信息+已登录
        if (newCardItems && newCardItems.length !== 0) {
          return domThree;
        }
        return false;
      }
    };

    const formatDataKC = (newTableId, newMemberVO, newCardItems, domOne, domTwo) => {
      // 快餐
      if (tableId && !memberVO) {
        // 带桌台信息+未登录
        return domOne;
      } else if (tableId && memberVO) {
        // 带桌台信息+已登录
        if (cardItems && cardItems.length !== 0) {
          return domTwo;
        }
        return domOne;
      } else if (!tableId && memberVO) {
        // 不带桌台信息+已登录
        if (cardItems && cardItems.length !== 0) {
          return domTwo;
        }
        return false;
      }
    };

    switch (shopDetail.diningForm) {
      case 0: {
        // 正餐 (分为一桌一单 + 一桌多单)
        let domOne;
        let domTwo;
        let domThree;
        if (serviceCardVO && serviceCardVO.tableWay) {
          domOne = (
            <div>
              {this.cardLoginAndOrder(serviceCardVO, detailUrl, addDishUrl, dishUrl)}
              {this.getSocketCardItems(memberVO)}
              {this.cardDefault(serviceCardVO, dishUrl)}
            </div>
          );
          domTwo = (
            <div>
              {this.getSocketCardItems(memberVO)}
              {this.cardDefault(serviceCardVO, dishUrl)}
            </div>
          );
          domThree = (
            <div>
              {this.cardLoginAndOrder(serviceCardVO, detailUrl, addDishUrl, dishUrl)}
              {this.cardDefault(serviceCardVO, dishUrl)}
            </div>
          );
        }

        if (serviceCardVO.tableWay === 'oneTableOneBill' || serviceCardVO.tableWay === 'oneTableMoreBill') {
          return formatDataZC(tableId, memberVO, cardItems, domOne, domTwo, domThree);
        }
        break;
      }
      case 1: {
        // 快餐
        const domOne = this.cardDefault(serviceCardVO, dishUrl);
        const domTwo = (
          <div>
            {this.cardLoginAndOrder(serviceCardVO, detailUrl, addDishUrl, dishUrl)}
            {this.cardDefault(serviceCardVO, dishUrl)}
          </div>
        );
        return formatDataKC(tableId, memberVO, cardItems, domOne, domTwo);
      }
      default:
        break;
    }

    return true;
  }

  getDishway_(data) {
    const { serviceApproach, diningForm } = this.props.shopDetail;
    let getDishway = '';
    if (isFormalMeal(diningForm)) {
      getDishway = data.tableAreaDesc;
    } else if (diningForm === 1) {
      if (serviceApproach === 'totable,pickup' || serviceApproach === 'pickup,totable') {
        getDishway = data.tableAreaDesc;
      } else if (serviceApproach === 'totable') {
        getDishway = formatMessage(shopText.shoptoTable);
      } else if (serviceApproach === 'pickup') {
        getDishway = formatMessage(shopText.shopgetFoods);
      }
    }
    return getDishway;
  }

  // 卡片，没登录，没订单 diningForm区分快餐，正餐
  cardDefault(data, url) {
    const table = `&tableId=${tableId}`;
    const { diningForm } = this.props.shopDetail;
    const { memberVO, cardItems = [], tableAreaDesc, hasActiveOrder } = this.props.serviceCardVO;

    let word = '';
    let oneTableOneBillHasActiveOrder = false;
    const { serviceCardVO, activeSocketCard, socketCardData = [] } = this.props;

    // 一桌一单如果有socketCardData 就不能展示开始点餐
    if (isFormalMeal(diningForm) && serviceCardVO.tableWay === 'oneTableOneBill' && socketCardData.length > 0) {
      return;
    }

    /* 如果是一桌一单的情况下 如果有活跃订单 则不展示开始点餐选项卡 */

    (cardItems || []).forEach((item, index) => {
      // 检测cardItems无值或不返回的情况
      if (!item) {
        return;
      }
      if (
        item.orderStatus === ShopCardOrderStatus.AWAITCOMMERCIALCONFIRM ||
        item.orderStatus === ShopCardOrderStatus.ORDERCONFIRMED ||
        item.orderStatus === ShopCardOrderStatus.AWAITCOMMERCIALCONFIRMADDDISH
      ) {
        oneTableOneBillHasActiveOrder = true;
      }
    });

    const formatDataZC = (newTableId, newMemberVO, newCardItems, tableWay) => {
      // 正餐
      let lockNumber = 1;
      if ((tableWay === 'oneTableOneBill' && oneTableOneBillHasActiveOrder) || activeSocketCard) {
        // 一桌一单有活跃订单不展示开始点餐按钮或者协同购物车有活跃单
        lockNumber = 0;
      }

      switch (tableWay) {
        case 'oneTableOneBill':
          if (newTableId && !newMemberVO && newCardItems && newCardItems.length !== 0 && hasActiveOrder) {
            // 带桌台信息+未登录
            lockNumber = 0;
          } else if (newTableId && newMemberVO && newCardItems && newCardItems.length !== 0 && hasActiveOrder) {
            // 带桌台信息+已登录
            lockNumber = 0;
          } else if (!newTableId && newMemberVO && newCardItems && newCardItems.length !== 0 && hasActiveOrder) {
            // 不带桌台信息+已登录
            lockNumber = 0;
          } else if (!newTableId && newMemberVO && (!newCardItems || newCardItems.length === 0)) {
            // 不带桌台信息+已登录
            lockNumber = 0;
          }
          break;
        case 'oneTableMoreBill':
          if (newTableId && newMemberVO && newCardItems && newCardItems.length !== 0 && hasActiveOrder) {
            // 带桌台信息+已登录
            lockNumber = 0;
          } else if (!newTableId && newMemberVO && newCardItems && newCardItems.length !== 0 && hasActiveOrder) {
            // 不带桌台信息+已登录
            lockNumber = 0;
          } else if (!newTableId && newMemberVO && (!newCardItems || newCardItems.length === 0)) {
            // 不带桌台信息+已登录
            lockNumber = 0;
          }
          break;
        default:
          break;
      }
      return lockNumber;
    };

    /* 如果是一桌一单的情况下 如果有活跃订单 则不展示开始点餐选项卡 */
    switch (diningForm) {
      case 0: {
        if (serviceCardVO.tableWay === 'oneTableOneBill') {
          word = formatMessage(shopText.shopstartOrderring);
        } else if (serviceCardVO.tableWay === 'oneTableMoreBill') {
          word = formatMessage(shopText.shopnewOrder);
        }

        const dataZC = formatDataZC(tableId, memberVO, cardItems, serviceCardVO.tableWay);
        if (!dataZC) {
          return false;
        }
        break;
      }
      case 1:
        word = formatMessage(shopText.shopstartPaying);
        break;
      default:
        break;
    }

    const redictToUrl = () => {
      switch (diningForm) {
        case 0:
          if (!memberVO) {
            // 需要登录之后才能点餐
            this.redirect();
          } else {
            const ownerId = memberVO.customerId ? `&ownerId=${memberVO.customerId}` : '';
            location.href = `${url}${tableId ? table : ''}${ownerId}`;
          }
          break;
        case 1:
          location.href = `${url}${tableId ? table : ''}`;
          break;
        default:
          break;
      }
    };

    return (
      <div>
        <div className="shop-card_box o-pr o-br o-pl o-mb">
          <div className="card-info card-info--step2 card-info--modify o-pl o-pr">
            <div className="card-info-customer o-mb o-flex">
              <div className="card-info-customer o-flex o-flex__fluid ellipsis">
                <span>
                  <HttpsProtocolImage src={(memberVO && memberVO.iconUri) || defaultPeople} alt="" className="shop-card-img shop-card--small" />
                </span>
                <span className="o-fz--16 shop-card-name ellipsis">
                  {(memberVO && memberVO.name) || (memberVO && memberVO.mobile) || formatMessage(shopText.shopunLogin)}
                </span>
              </div>
              <div className="o-flex__fixed o-flex o-flex--column card-info-customer__tablewidthstatus">
                <span className="o-label">{tableAreaDesc}</span>
              </div>
            </div>
            <div className="clear--modify" style={{ marginTop: '35px' }}>
              <a href=" javascript:void(0)" onTouchTap={redictToUrl} className="o-label o-label--middle o-ta--c o-mt o-fz--15">
                {word}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 卡片 有订单 不管登录与否 iningForm区分快餐，正餐
  cardLoginAndOrder(data, detailUrl, addDishUrl, dishUrl, departActive) {
    const { diningForm } = this.props.shopDetail;
    const { memberVO } = this.props.serviceCardVO;
    const redirectUrlMethod = (url, hasUrl) => {
      if (!memberVO) {
        // 需要登录之后才能点餐
        this.redirect(hasUrl ? url : '');
      } else {
        location.href = url;
      }
    };
    return (
      <div>
        {(data.cardItems || []).map((item, index) => {
          const returnUrl = encodeURIComponent(`${config.orderallDetailURL}?shopId=${shopId}&orderId=${item.tradeId}&listEntry=true`);
          let dishStatus = '';
          let reasonContent = '';
          let url = detailUrl;
          const table = item.tableSyn ? `&tableId=${item.tableSyn}` : '';
          const orderId = item.tradeId ? `&orderId=${item.tradeId}` : '';
          const ownerId = item.ownerId ? `&ownerId=${item.ownerId}` : '';
          if (
            (item.orderStatus === ShopCardOrderStatus.ORDERDONE ||
              item.orderStatus === ShopCardOrderStatus.ORDEROBSOLETE ||
              item.orderStatus === ShopCardOrderStatus.ORDERREFUSED) &&
              isFormalMeal(diningForm)
          ) {
            // 正餐完成订单
            url = `${config.orderallDetailURL}?shopId=${shopId}`;
          }

          switch (item.orderStatus) {
            case ShopCardOrderStatus.AWAITCOMMERCIALCONFIRM:
              dishStatus = formatMessage(shopText.shopwaitFotComfirm);
              break;
            case ShopCardOrderStatus.ORDERCONFIRMED:
              dishStatus = formatMessage(shopText.shoporderConfirmed);
              break;
            case ShopCardOrderStatus.AWAITCOMMERCIALCONFIRMADDDISH:
              dishStatus = formatMessage(shopText.shopconfirmAddDish);
              break;
            case ShopCardOrderStatus.ORDERDONE:
              dishStatus = formatMessage(shopText.shoporderComplete);
              break;
            case ShopCardOrderStatus.ORDEROBSOLETE:
              dishStatus = formatMessage(shopText.shopDropped);
              reasonContent = item.reasonContent;
              break;
            case ShopCardOrderStatus.ORDERREFUSED:
              dishStatus = formatMessage(shopText.shoporderConfused);
              reasonContent = item.reasonContent;
              break;
            default:
              break;
          }

          if (item.checkoutBtn) {
            dishStatus = formatMessage(shopText.shoptobePaid);
          }

          return (
            <div key={index}>
              <div className="shop-card_box o-pr o-br o-pl o-mb">
                <div className="card-info card-info--step1 card-info--modify o-pl o-pr">
                  <div className="card-info-customer__outer o-flex">
                    <div className="card-info-customer o-flex o-flex__fluid ellipsis">
                      <span>
                        <HttpsProtocolImage src={item.iconUri || defaultPeople} alt="" className="shop-card-img shop-card--small" />
                      </span>
                      <span className="o-fz--16 shop-card-name ellipsis">{item.name || item.mobile || formatMessage(shopText.shopAnonymous)}</span>
                    </div>
                    <div className="o-flex__fixed o-flex o-flex--column card-info-customer__tablewithstatus">
                      <span className="o-label">{this.getDishway_(item)}</span>
                      <span className="o-fz--12 card-info-customer__reasonStatus">{dishStatus}</span>
                      <span className="o-fz--12 card-info-customer__reasonContent">{reasonContent}</span>
                    </div>
                  </div>
                  <div className="clear--modify o-ta--l">
                    <p className="o-fz--14 clear--modify--already">
                      <FormattedMessage {...shopText.shopordered} />
                      <span className="clear--modify--alreadynum">{item.allDishNum}</span>
                      <FormattedMessage {...shopText.shoporderedDish} />
                    </p>
                  </div>
                  <div className="clear--modify o-ta--l">
                    <p className="o-fz--14 p-overflow" style={{ width: '100%' }}>
                      {item.allDish}
                    </p>
                  </div>
                  <div className="clear--modify o-ta--r">
                    {isFormalMeal(diningForm) && item.addDishBtn === true && !this.props.serviceCardVO.payFirst && (
                      <a
                        href=" javascript: void(0)"
                        className="o-label o-label--small o-ta--c o-mt"
                        onTouchTap={() => {
                          redirectUrlMethod(`${addDishUrl}${table}${orderId}${ownerId}&comeFromShopIndex=true`);
                        }}
                      >
                        <FormattedMessage {...shopText.shopaddDishs} />
                      </a>
                    )}
                    {diningForm === 1 && item.checkoutBtn && (
                      <a
                        href=" javascript: void(0)"
                        className="o-label o-label--small o-ta--c o-mt"
                        onTouchTap={e => {
                          redirectUrlMethod(
                            `${config.payDetailURL}?shopId=${shopId}&orderId=${item.tradeId}orderType=TS&returnUrl=${returnUrl}`,
                            true
                          );
                        }}
                      >
                        <FormattedMessage {...shopText.shopgotoPay} />
                      </a>
                    )}
                    <a
                      href=" javascript:void(0)"
                      className="o-label o-label--small o-ta--c o-mt"
                      onTouchTap={() => {
                        redirectUrlMethod(`${url}${table}${orderId}`, true);
                      }}
                    >
                      <FormattedMessage {...shopText.shopcheckDetail} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  redirect(redirectUrl) {
    this.props.setToastProps({
      className: 'order-dish-login-msgbox',
      mainMessage: formatMessage(shopText.shoplogToNext),
      buttonProp: { text: formatMessage(globalMessage.goToLogin), className: 'o-tc--primary' },
      imgProp: 'login',
      onBtnTap: () => {
        pageHelper.navigateToLoginPage({
          shopId,
          returnUrl: encodeURIComponent(redirectUrl || location.href),
        });
      },
    });
  }
  getSocketCardItems(memberVO) {
    const { socketCardData = [], shopDetail, serviceCardVO } = this.props;
    const { cardItems = [], hasActiveOrder } = this.props.serviceCardVO;
    let oneTableOneBillHasActiveOrder = false;
    /* 如果是一桌一单的情况下 如果有活跃订单 则不展示加入点餐选项卡 */
    cardItems.forEach((item, index) => {
      if (
        item.orderStatus === ShopCardOrderStatus.AWAITCOMMERCIALCONFIRM ||
        item.orderStatus === ShopCardOrderStatus.ORDERCONFIRMED ||
        item.orderStatus === ShopCardOrderStatus.AWAITCOMMERCIALCONFIRMADDDISH
      ) {
        oneTableOneBillHasActiveOrder = true;
      }
    });

    if (
      !isFormalMeal(shopDetail.diningForm) ||
      (serviceCardVO.tableWay === 'oneTableOneBill' && (hasActiveOrder || oneTableOneBillHasActiveOrder))
    ) { // 非正餐
      return;
    }

    const addDishUrl = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=TS&addDishes=true`; // 加菜 正餐
    const redirectUrlMethod = (table, orderId, ownerId) => {
      if (!memberVO) {
        // 需要登录之后才能点餐
        this.redirect();
      } else {
        location.href = `${addDishUrl}${table}${orderId}${ownerId}`;
      }
    };

    return socketCardData.map((item, index) => {
      const table = item.tableId ? `&tableId=${item.tableId}` : '';
      const orderId = item.orderId ? `&orderId=${item.orderId}` : '';
      const ownerId = item.owner.ownerId ? `&ownerId=${item.owner.ownerId}` : '';
      const iconUrl = (serviceCardVO.tableWay === 'oneTableOneBill' ? memberVO.iconUri : item.owner.userPicPath) || defaultPeople;
      const userNickname = serviceCardVO.tableWay === 'oneTableOneBill' ? memberVO.name : item.owner.userNickname;
      let methodInfoOne = memberVO && item.owner.ownerId === memberVO.customerId ? formatMessage(shopText.shopgoOnOrder) : formatMessage(shopText.wantToJoin);
      let methodInfoTwo =
        memberVO && item.owner.ownerId === memberVO.customerId ? formatMessage(shopText.shopgoOnOrder) : formatMessage(shopText.shopaddToOrder);
      if (serviceCardVO.tableWay === 'oneTableOneBill') {
        methodInfoOne = methodInfoTwo = formatMessage(shopText.shopgoOnOrder);
      }
      return (
        <div key={index}>
          <div className="shop-card_box o-pr o-br o-pl o-mb">
            <div className="card-info card-info--step3 card-info--modify o-pl o-pr">
              <div className="card-info-customer__outer o-flex">
                <div className="card-info-customer o-flex o-flex__fluid ellipsis">
                  <span>
                    <HttpsProtocolImage src={iconUrl} alt="" className="shop-card-img shop-card--small" />
                  </span>
                  <span className="o-fz--16 shop-card-name ellipsis">{userNickname}</span>
                </div>
              </div>
              <p className="o-fz--14">
                <FormattedMessage {...shopText.shopordering} values={{ methodInfoOne }} />
              </p>
              <div className="clear--modify">
                <a
                  href=" javascript:void(0)"
                  className="o-label o-label--middle o-ta--c o-mt o-fz--15"
                  onTouchTap={() => {
                    redirectUrlMethod(table, orderId, ownerId);
                  }}
                >
                  {methodInfoTwo}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  closeWindow() {
    this.props.setToastProps(null);
  }
  render() {
    const shopCardName = this.getShopCardName();
    let cardItems = this.getCardItems();
    const { toastProps } = this.props;
    return (
      <div className="o-flex shop-card ">
        <div className="o-flex__fluid" style={{ width: '100%' }}>
          {shopCardName}
          {cardItems}
        </div>
        {toastProps && (
          <SyncOrderToast
            toastProps={toastProps}
            onCloseWindow={this.closeWindow}
          />
        )}
      </div>
    );
  }
}

ShopCard.propTypes = {
  fetchShopDetail: React.PropTypes.func,
  setSocketCardData: React.PropTypes.func,
  shopDetail: React.PropTypes.object,
  userInfo: React.PropTypes.object,
  serviceCardVO: React.PropTypes.object,
  socketCardData: React.PropTypes.array,
  activeSocketCard: React.PropTypes.bool,
  setToastProps: React.PropTypes.func,
  toastProps: React.PropTypes.object,
  enableSyncShoppingCart: React.PropTypes.number,
};

export default ShopCard;



// WEBPACK FOOTER //
// ./src/component/shop-home/shop-card.jsx